import React, {Component} from 'react';
import { Translate } from 'react-redux-i18n';
import axios from 'axios';
import {ROOT_URL} from '../../actions/root_url';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import {DateFormatter} from '../Common/dateFormat';
import { Button } from 'react-bootstrap';
const actions = {
  'Edit': <Translate value="edit"/>,
  'Set_Review': <Translate value="set_review" />,
  'Review': <Translate value="mfg_review"/>,
  'Req_Review': <Translate value="mfg_review"/>,
  'Set_Approve': <Translate value="set_approve" />,
  'Approve': <Translate value="approve" />,
  'Req_Approve': <Translate value="approve" />,
  'Create': <Translate value="create" />
}
const results = {
  'ReviewPending': <Translate value="Pending" />,
  'ReviewConfirm': <Translate value="Confirm" />,
  'ReviewReject': <Translate value="Reject" />,
  'ApprovePending': <Translate value="approval_pending" />,
  'ApproveConfirm': <Translate value="approval_confirm" />,
  'ApproveReject': <Translate value="Reject" />,
  'Req_ReviewPending': <Translate value="Pending" />,
  'Req_ReviewConfirm': <Translate value="Confirm"/>,
  'Req_ReviewReject': <Translate value="Reject"/>,
  'Req_ApprovePending': <Translate value="approval_pending" />,
  'Req_ApproveConfirm': <Translate value="approval_confirm" />,
  'Req_ApproveReject': <Translate value="Reject" />
}

class Timeline extends Component {
  constructor() {
    super();
    this.state = {
      rows: [],
      isLoading: false,
    }
  }

  componentDidMount() {
    const {
      num,
      module
    } = this.props;
    if (num && num !== 'new') {
      this.fetchData(num, module);
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.num !== this.props.num) {
      if (nextProps.num && nextProps.num !== 'new') {
        this.fetchData(nextProps.num, this.props.module);
      }
    }
  }

  fetchData = (num, module) => {
    this.setState({
      isLoading: true,
    });
    axios({
      url: `${ROOT_URL}v1/mfg/log/order?Module=${module}&Num=${num}`,
      method: 'GET',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    })
      .then(response => {
        if (response.status !== 200) {
          alert(response.data);
        } else {
          this.setState({
            rows: response.data
          });
        }
        this.setState({
          isLoading: false,
        });
      })
  }
  handleRevokeLog = (original) => {
    let logIdArr = []
    logIdArr.push(original.ReviewOrApproveLog_id);
    let dataLength = this.state.rows.length
    let lastData = this.state.rows[dataLength - 1]
    let lastPreData = this.state.rows[dataLength - 2]
    if(lastData.Result === 'Confirm' || lastData.Result === 'Reject') {
      if (lastPreData && lastData.Handle === lastPreData.Handle) {
        logIdArr.push(lastPreData.ReviewOrApproveLog_id)
      }
    }
    axios({
      url: `${ROOT_URL}v1/mfg/approve_order_rollback/`,
      method: 'put',
      data: {
        log_ids: logIdArr.join(','),
      },
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }).then(response => {
      alert(response.data);
      if (response.status === 200) {
        const { num, module } = this.props;
        if (num && num !== 'new') {
          this.fetchData(num, module);
        }
      }
    })
  }

  render() {
    const getRows = () => {
      return Data.Selectors.getRows(this.state);
    }

    const getSize = () => {
      return getRows().length;
    }

    const rowGetter = rowIdx => {
      let rows = getRows();
      return Object.assign({ Idx: rowIdx+1 }, rows[rowIdx]);
    }
    const handleGridSort = (sortColumn, sortDirection) => {
      let state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
      this.setState(state);
    }
    const isSo = this.props.module === 'so';
    const isPurchaseReturn = this.props.module === 'return';
    const columns = [
      {
        key: 'Idx',
        name: <Translate value="idx" />,
        width: 30,
        resizable: false,
        filterable: true,
      },
      {
        name: <Translate value="action_name" />,
        width: 120,
        key: 'Handle',
        getRowMetaData: (row) => row,
        formatter: row => {
          return <span>{actions[row.value] || 'unknown'}</span>
        }
      },
      {
        name: <Translate value="result"/>,
        width: 80,
        key: 'Result',
        getRowMetaData: (row) => row,
        formatter: row => <span>{results[row.dependentValues.Handle + row.value] || 'unknown'}</span>
      },
      {
        name: <Translate value="user" />,
        width: 80,
        key: 'Place_User_Name'
      },
      {
        name: <Translate value="datetime" />,
        key: 'CreateTime',
        formatter: DateFormatter
      },
      {
        name: <Translate value="action" />,
        key: 'action',
        getRowMetaData: (row) => row,
        formatter: ({ dependentValues }) => {
          let dataLength = this.state.rows.length
          let revokeBtnVisible = dataLength && dependentValues.Idx === dataLength && dependentValues.Place_User_id_id === parseInt(localStorage.getItem('BaseUser_id'))
          let lastData = this.state.rows[dataLength - 1]
          if(revokeBtnVisible) {
            if (isSo || isPurchaseReturn && !(lastData.Handle === 'Approve' && lastData.Result === 'Confirm')) {
              return <Button
                style={{background: '#F44336'}}
                onClick={() => { this.handleRevokeLog(dependentValues) }}
              >
                <Translate value="revoke" />
              </Button>
            } else {
              return null
            }
          } else {
            return null
          }
        }
      }
    ];
    return (
      <Row>
        <Col sm={ 12 }>
          <h2 className="mt0"><Translate value="action_log"/></h2>
          <div style={{ maxWidth: '100%' }} id="PurchaseReturnForm-dataGrid1">
            <ReactDataGrid
              onGridSort={handleGridSort}
              columns={columns}
              rowHeight={25}
              minHeight={400}
              rowGetter={rowGetter}
              rowsCount={getSize()}
            />
          </div>
        </Col>
      </Row>
    )
  }
}

Timeline.propTypes = {
  num: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  module: PropTypes.string.isRequired
};
export default Timeline;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/actionTimeline.jsx